import { Action, createReducer, on } from "@ngrx/store";
import { Course } from "cli-types";
import * as fromCoursesActions from "../actions/courses.action";

// creating an interface to say what type the initialState will be
// using entities (data objects) instead of arrays is better for performance
export interface CartClassesListState {
    entities: Map<number, Course>;
    loaded: boolean;
    loading: boolean;
}

// set initial state as type CoursesListState
export const initialState: CartClassesListState = {
    entities: new Map(),
    loaded: false,
    loading: false,
};

const cartClassesListReducer = createReducer(
    initialState,
    on(fromCoursesActions.loadClassesForSubject, (state) => {
        return {
            ...state,
            loading: true,
            loaded: false,
        };
    }),
    on(
        fromCoursesActions.loadClassesForSubjectSuccess,
        (state, { payload }) => {
            const courses: Course[] = payload.data;
            const entities = new Map<number, Course>();

            courses.forEach((course) => {
                entities.set(course.courseID, course);
            });

            return {
                ...state,
                loading: false,
                loaded: true,
                entities: entities,
            };
        }
    ),
    on(fromCoursesActions.loadClassesForSubjectFail, (state, { payload }) => {
        return {
            ...state,
            loading: false,
            loaded: false,
        };
    })
);

export function reducer(
    state: CartClassesListState | undefined,
    action: Action
) {
    return cartClassesListReducer(state, action);
}

// this is where we want to export some levels of state
export const getClassesForSubjectEntities = (state: CartClassesListState) =>
    state.entities;
export const getClassesForSubjectLoading = (state: CartClassesListState) =>
    state.loading;
// export loaded and filtered against selectedCourse
export const getClassesForSubjectLoaded = (state: CartClassesListState) =>
    state.loaded;
